import { type FunctionComponent } from 'react';
import { type ChannelOptions, type ChannelSort } from 'stream-chat';
import {
  ChannelList as StreamChannelList,
  type ChannelListProps as StreamChannelListProps,
} from 'stream-chat-react';
import { assert } from 'ts-essentials';
import { ChannelPreview } from '../ChannelPreview/ChannelPreview';
import { EmptyChannelList } from '../EmptyChannelList/EmptyChannelList';

const defaultOptions: ChannelOptions = {
  limit: 30,
  presence: true,
  state: true,
  watch: true,
};

const defaultSort: ChannelSort = {
  last_message_at: -1,
  updated_at: -1,
};

export type ChannelListProps = StreamChannelListProps & {
  type?: 'ccm_community' | 'ccm_member_sharing';
};

export const ChannelList: FunctionComponent<ChannelListProps> = ({
  options = defaultOptions,
  sort = defaultSort,
  type,
  ...props
}) => {
  const { filters } = props;
  assert(filters);

  const emptyStateIndicator = type
    ? () => <EmptyChannelList type={type} />
    : () => <div />;

  return (
    <StreamChannelList
      channelRenderFilterFn={(channels) => {
        return channels.filter((c) => c.type === filters.type);
      }}
      EmptyStateIndicator={emptyStateIndicator}
      options={options}
      Preview={ChannelPreview}
      sort={sort}
      {...props}
    />
  );
};
